import { LocalisedString } from '@provider-portal/common/api/types';

export function getLocalisedStringValue(localisedString: LocalisedString | null): string | null {
  return localisedString ? localisedString.value : null;
}

export function getLocalisedStringValueOrEmpty(localisedString: LocalisedString | null): string {
  return localisedString ? localisedString.value : '';
}
